import script from "./TitledSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitledSelection.vue?vue&type=script&setup=true&lang=ts"

import "./TitledSelection.vue?vue&type=style&index=0&id=667ce2c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667ce2c8"]])

export default __exports__